import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/icon/change-blue.svg'
import _imports_1 from '@/assets/img/icon/action/bus-outline-blue.svg'
import _imports_2 from '@/assets/img/icon/user-outlined-blue.svg'


const _hoisted_1 = { class: "rit-options" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "md:flex items-center gap-2" }
const _hoisted_5 = { class: "border-right-grey-lighten-3 text-xs px-2" }
const _hoisted_6 = { class: "border-right-grey-lighten-3 flex items-center gap-2 px-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "rit"
}, null, -1)
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = { class: "border-right-grey-lighten-3 flex items-center gap-2 px-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "bus"
}, null, -1)
const _hoisted_11 = { class: "text-xs" }
const _hoisted_12 = { class: "flex items-center gap-2 px-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "condectur"
}, null, -1)
const _hoisted_14 = { class: "text-xs" }
const _hoisted_15 = { class: "md:flex items-center gap-2 py-1" }
const _hoisted_16 = { class: "border-right-grey-lighten-3 text-xs px-2" }
const _hoisted_17 = { class: "border-right-grey-lighten-3 flex items-center gap-2 px-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "rit"
}, null, -1)
const _hoisted_19 = { class: "text-xs" }
const _hoisted_20 = { class: "border-right-grey-lighten-3 flex items-center gap-2 px-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "bus"
}, null, -1)
const _hoisted_22 = { class: "text-xs" }
const _hoisted_23 = { class: "flex items-center gap-2 px-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "condectur"
}, null, -1)
const _hoisted_25 = { class: "text-xs" }

import {
  ref,
  toRefs,
  computed,
  watch,
  withDefaults,
  onMounted,
  nextTick
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import
vSelect,
{
  VueSelectProps
} from 'vue-select'
import { useIntersectionObserver, useDebounceFn } from '@vueuse/core'
import moment from 'moment'

interface IPropsSelectAsync extends Partial<VueSelectProps> {
  endpoint: string
  fieldValue?: string
  fieldLabel?: (item: any) => string
  searchFields?: Array<string>
  modelValue?: any
  searchCustom?: Array<any>
  id?: string
  classname?: string
  selectable?: (item: any) => boolean
  inputId: string
  placeholder: string
  disabled: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAsyncRitOptions',
  props: {
    endpoint: { default: '' },
    fieldValue: { default: 'Id' },
    fieldLabel: { type: Function, default: () => 'Name' },
    searchFields: { default: () => [] },
    modelValue: { default: null },
    searchCustom: { default: () => [] },
    id: { default: '' },
    classname: { default: '' },
    selectable: { type: Function, default: () => true },
    inputId: { default: '' },
    placeholder: { default: 'Pilih' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change", "search:focus"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', val: any): void
  (e: 'change', val: any): void
  (e: 'search:focus'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { endpoint: string, fieldValue: string, fieldLabel: (item: any) => string, searchFields: Array<string>, modelValue: any, searchCustom: Array<any>, id: string, classname: string, selectable: (item: any) => boolean, inputId: string, placeholder: string, disabled: boolean }





const {
  endpoint,
  fieldLabel,
  modelValue,
  inputId,
  placeholder,
  clearable,
  fieldValue,
  searchFields,
  searchCustom,
  id,
  selectable,
  classname
} = toRefs(props)

const isLoading = ref(false)
const options = ref([]) as any
const inputSearch = ref('')

const valueSelect = computed({
  get: () => modelValue?.value,
  set: (v) => {
    emit('update:modelValue', v)
  }
})
const hasNextPage = ref(false)
const load = ref(null) as unknown as HTMLElement
const targetIsVisible = ref(false)
const pagination = {
  count: 0,
  pageNumber: 1,
  pageSize: 10,
  limit: 0
}

const selectableRow = (row: any) => selectable?.value(row)

// eslint-disable-next-line consistent-return
// const selectableRule = (val: any) => {
//   console.log('vall=>', val)
//   if (selectableParams.value.length > 0) {
//     if (lowerCase(selectableParams.value[1]) === 'equal') {
//       if (val[`${selectableParams.value[0]}`] === selectableParams.value[2]) {
//         return true
//       }
//       return false
//     }
//     if (lowerCase(selectableParams.value[1]) === 'notequal') {
//       if (val[`${selectableParams.value[0]}`] !== selectableParams.value[2]) {
//         return true
//       }
//       return false
//     }
//   }
//   return true
// }
let requestId = 0
const getData = async () => {
  const currentRequestId = ++requestId

  try {
    isLoading.value = true
    const { result, error, count, pagenumber } = await apiUseCase.get(`${endpoint.value}${returnUrlPrams({
      search: inputSearch.value,
      filterField: searchFields.value,
      custom: searchCustom.value,
      pageNumber: pagination.pageNumber
    })}`)
    if (currentRequestId !== requestId) return

    if (!error) {
      if (pagenumber === 1) {
        pagination.limit = 0
        pagination.count = 0
        options.value = []
        // console.log('optionsreset', [inputSearch.value, options.value])
      }
      pagination.limit = count
      pagination.count += result.length
      // console.log([pagination.limit, pagination.count])
      if (pagination.count < pagination.limit) {
        hasNextPage.value = true
        pagination.pageNumber += 1
      } else {
        hasNextPage.value = false
      }

      // console.log('asadad', hasNextPage.value)
      // eslint-disable-next-line array-callback-return
      result.map((item: any) => {
        const data = {
          dataParent: item,
          label: {
            TrxId: item.TransactionPp?.TrxId ?? '-',
            CondecturName: item.TransactionPp?.CondecturName ?? '-',
            VehicleRegNumber: item.TransactionPp?.VehicleRegNumber ?? '-',
            DepartureTime: item.TransactionPp?.DepartureTime
              ? item.TransactionPp.DepartureTime.slice(0, 5)
              : '-',
            RitOrder: item.RitOrder ?? '-'
          },

          searchLabel: [
            item.TransactionPp?.TrxId,
            item.TransactionPp?.CondecturName,
            item.TransactionPp?.VehicleRegNumber,
            item.TransactionPp?.DepartureTime,
            item.RitOrder
          ]
            .filter(Boolean)
            .join(' '),

          value: item[fieldValue.value]
        }
        options.value.push(data)
      })
      // console.log('options', options.value)
    }
    isLoading.value = false
  } catch (err) {
    isLoading.value = false
  }
}

const onOpen = () => {
  // console.trace('OPENED')
  // console.log(document.activeElement)
  // console.trace()
  if (pagination.count === 0) {
    getData()
  }
  emit('search:focus')
}

const onSearch = (val: any) => {
  // console.log('valSearch', val)
  if (val !== inputSearch.value) {
    pagination.pageNumber = 1
    options.value = []
    hasNextPage.value = false
    inputSearch.value = val
    getData()
  }
}

const { stop } = useIntersectionObserver(load, ([{ isIntersecting }], observerElement) => {
  targetIsVisible.value = isIntersecting

  const documentId = document.querySelector('#load') as HTMLElement

  const ul = documentId.offsetParent as any
  const xxxx = documentId.offsetParent?.scrollTop
  ul.scrollTop = xxxx
  // console.log('xxx', [xxxx, ul])
  if (targetIsVisible.value) {
    // pagination.pageNumber += 1
    // searchCustom.value = []
    // searchCustom.value.push(['pageNumber', '=', pagination.pageNumber])
    getData()
  }
})

// const onSearch = debounce(getData, 500)

const debounceSearch = useDebounceFn(() => {
  getData()
}, 500)

const optionSelected = (select: any) => {
  // console.log('selec', select)
  emit('change', select)
}

watch(valueSelect, (val: any) => {
  // console.log('WATCH VALUE', val)
  // console.log('val', val)
  if (!val) {
    emit('change', val)
  }
})

onMounted(async () => {
  await nextTick()

  setTimeout(() => {
    const active = document.activeElement as HTMLElement

    if (active?.classList.contains('vs__search')) {
      active.blur()
    }
  }, 0)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(vSelect), {
      class: _normalizeClass(`select-default ${_unref(classname)}`),
      inputId: _unref(inputId),
      placeholder: _unref(placeholder),
      clearable: _unref(clearable),
      id: _unref(id),
      disabled: __props.disabled,
      options: _unref(options),
      modelValue: _unref(valueSelect),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valueSelect) ? (valueSelect).value = $event : null)),
      onOpen: onOpen,
      onSearch: onSearch,
      label: "searchLabel",
      selectable: selectableRow,
      "onOption:selected": optionSelected,
      "onOption:deselecting": optionSelected,
      loading: isLoading.value,
      autofocus: false
    }, {
      "list-footer": _withCtx(() => [
        (hasNextPage.value)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              ref_key: "load",
              ref: load,
              id: "load",
              class: "loader"
            }, " Sedang memuat... ", 512))
          : _createCommentVNode("", true)
      ]),
      "no-options": _withCtx(({ searching, loading }) => [
        searching
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Tidak ada data ditemukan. "))
          : _createCommentVNode("", true),
        loading
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Tidak ada data ditemukan. "))
          : _createCommentVNode("", true)
      ]),
      "selected-option": _withCtx(({ dataParent }) => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(dataParent.TransactionPp?.TrxId ?? '-'), 1),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(`Rit ${dataParent.RitOrder} - ${dataParent.TransactionPp?.DepartureTime ? dataParent.TransactionPp?.DepartureTime.slice(0, 5) : '-'}`), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(dataParent.TransactionPp?.VehicleRegNumber ?? '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(dataParent.TransactionPp?.CondecturName ?? '-'), 1)
          ])
        ])
      ]),
      option: _withCtx(({ dataParent }) => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(dataParent.TransactionPp?.TrxId ?? '-'), 1),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, _toDisplayString(`Rit ${dataParent.RitOrder} - ${dataParent.TransactionPp?.DepartureTime ? dataParent.TransactionPp?.DepartureTime.slice(0, 5) : '-'}`), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, _toDisplayString(dataParent.TransactionPp?.VehicleRegNumber ?? '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, _toDisplayString(dataParent.TransactionPp?.CondecturName ?? '-'), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class", "inputId", "placeholder", "clearable", "id", "disabled", "options", "modelValue", "loading"])
  ]))
}
}

})